(() => {
  const recentKey = "miipas:recent";
  const soldLabel = "在庫なし";

  const readRecent = () => {
    try {
      return JSON.parse(localStorage.getItem(recentKey) || "[]");
    } catch (error) {
      return [];
    }
  };

  const saveRecent = (item) => {
    if (!item?.id) return;
    const items = readRecent().filter((entry) => String(entry.id) !== String(item.id));
    items.unshift(item);
    localStorage.setItem(recentKey, JSON.stringify(items.slice(0, 12)));
  };

  const handleOf = (entry) => {
    if (entry.handle) return entry.handle;
    const match = String(entry.url || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  };

  const yenText = (cents) => {
    const n = Number(cents);
    if (!Number.isFinite(n)) return "";
    return Math.round(n / 100).toLocaleString("ja-JP");
  };

  const loadLive = (entry) => {
    const handle = handleOf(entry);
    if (!handle) return Promise.resolve({ entry, live: null });
    return fetch(`/products/${handle}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((live) => ({ entry, live }))
      .catch(() => ({ entry, live: null }));
  };

  const variantsPayload = (live) => {
    const options = (live.options || []).map((option) => ({
      name: option.name || option,
      values: option.values || [],
    }));
    return {
      title: live.title,
      options,
      variants: (live.variants || []).map((variant) => ({
        id: variant.id,
        options: variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean),
        price: yenText(variant.price),
        available: variant.available,
      })),
    };
  };

  const fillCard = (node, entry, live) => {
    const available = live ? Boolean(live.available) : entry.available !== false;
    const title = live?.title || entry.title || "";
    const url = live ? `/products/${live.handle}` : entry.url || "#";
    const image = live?.featured_image || entry.image || "";
    const price = live ? yenText(live.price) : entry.price || "";
    const variants = live?.variants || [];
    const first = variants.find((variant) => variant.available) || variants[0];

    node.classList.toggle("is-soldout", !available);
    const link = node.querySelector(".cart-rec__link") || node;
    if (link.tagName === "A") link.href = url;
    const img = node.querySelector("img");
    if (img) {
      img.src = image;
      img.alt = title;
    }
    const name = node.querySelector(".pdp-card__name");
    const priceEl = node.querySelector(".pdp-card__price");
    if (name) name.textContent = title;
    if (priceEl) priceEl.innerHTML = `${price}<span class="pdp-card__yen">円</span>`;

    node.querySelector("[data-recent-sold]")?.remove();
    node.querySelector(".cart-rec__add")?.remove();
    node.querySelector("[data-variants]")?.remove();

    if (!available) {
      const label = document.createElement("span");
      label.className = "miipas-label";
      label.dataset.recentSold = "1";
      label.textContent = soldLabel;
      link.append(label);
      return;
    }
    if (!live) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "miipas-btn miipas-btn--outline cart-rec__add";
    button.textContent = "カートに入れる";
    if (variants.length > 1) {
      button.setAttribute("data-add-choose", "");
      const script = document.createElement("script");
      script.type = "application/json";
      script.setAttribute("data-variants", "");
      script.textContent = JSON.stringify(variantsPayload(live));
      node.append(button, script);
      return;
    }
    if (!first?.id) return;
    button.setAttribute("data-add-variant", String(first.id));
    node.append(button);
  };

  const signalRecentReady = () => {
    if (window.miipasRecentReady) return;
    window.miipasRecentReady = true;
    document.dispatchEvent(new CustomEvent("miipas:recent-ready"));
  };

  const fillShelf = (root) => {
    const currentId = root.dataset.currentId;
    const limit = Number(root.dataset.limit || 8);
    const items = readRecent()
      .filter((entry) => String(entry.id) !== String(currentId))
      .slice(0, limit);
    const track = root.querySelector("[data-shelf-track]");
    const template = root.querySelector("[data-shelf-card-template]");
    if (!track || !template || items.length === 0) return;

    items.forEach((entry) => {
      const node = template.content.firstElementChild.cloneNode(true);
      fillCard(node, entry, null);
      track.append(node);
      loadLive(entry).then(({ live }) => {
        if (live) fillCard(node, entry, live);
      });
    });
    root.classList.add("is-ready");
  };

  const boot = () => {
    document.querySelectorAll("[data-recent-product]").forEach((node) => {
      try {
        saveRecent(JSON.parse(node.textContent));
      } catch (error) {}
    });
    document.querySelectorAll("[data-recent-shelf]").forEach(fillShelf);
    signalRecentReady();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
